import CallUsIcon from './CallUsIcon'

export default CallUsIcon
